import { DotLegalCheckbox, DotLegalDeleteDialog } from "@dotlegal/dotlegal-ui-components";
import { Box } from "@mui/material";
import { Trans } from "react-i18next";
import { useTranslation } from "@localization/useTranslation";
import { RiskOperationalItem } from "../RiskOperationalOverview.types";
import { useRemoveEntityDialog } from "./RemoveEntityDialog.hooks";

export interface IRemoveEntityDialog {
    riskAreaId: string;
    entity: RiskOperationalItem;
    onRemoved: () => void;
    onClose: () => void;
}

function RemoveEntityDialog(props: IRemoveEntityDialog) {
    const { translateString } = useTranslation();
    const { removeEntity, deleteRiskAssessments, setDeleteRiskAssessments, inProgress } = useRemoveEntityDialog(props);

    return (
        <DotLegalDeleteDialog
            open
            headerText={translateString("removeEntity")}
            alertBodyText={<Trans i18nKey="removeEntityConfirmation" values={{ name: props.entity.name }} />}
            warningTranslation={translateString("warning")}
            deleteBtnText={translateString("remove")}
            cancelBtnText={translateString("cancel")}
            onDialogClose={props.onClose}
            onOkClick={removeEntity}
            inProgress={inProgress}
        >
            <Box sx={{ display: "flex", justifyContent: "center", marginTop: 2 }}>
                <DotLegalCheckbox
                    checked={deleteRiskAssessments}
                    onChange={setDeleteRiskAssessments}
                    label={translateString("removeEntityDeleteRiskAssessments")}
                />
            </Box>
        </DotLegalDeleteDialog>
    );
}

export default RemoveEntityDialog;
